import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { EmptyFieldValue } from '@/components/common/item-field-value/EmptyFieldValue';
import type { ItemDetailsTabAdapter } from './adapters/types';
import { useTabAdapter } from './context/TabAdapterContext';
import { InlineEditableText } from './tabs/InlineEditableText';

export const ItemNameField = () => {
  const { t } = useTranslation();
  const adapter = useTabAdapter<ItemDetailsTabAdapter>();
  const name = adapter.getFieldValue('name');

  const [localName, setLocalName] = useState(name);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    setLocalName(name);
  }, [name]);

  const handleNameBlur = async () => {
    if (localName !== name) {
      try {
        setError(null);
        await adapter.updateFieldValue('name', localName);
      } catch (err) {
        setError(
          err instanceof Error
            ? err
            : new Error(t(($) => $.adaptivePlanner.itemPanel.itemSection.itemNameUpdateFailed)),
        );
      }
    }
  };

  return (
    <div className="p-4">
      {adapter.isEditable('name') ? (
        <InlineEditableText
          id="item-name"
          value={localName}
          onChange={(e) => {
            setLocalName(e.target.value);
            if (error) setError(null);
          }}
          onBlur={handleNameBlur}
          ddActionName="item-panel-name"
          testId="portfolio-item-name-input"
          placeholder={t(($) => $.adaptivePlanner.itemPanel.itemSection.itemName)}
          error={!!error}
          helperText={error?.message}
          disabled={adapter.isDisabled('name')}
        />
      ) : name ? (
        <div
          data-testid="portfolio-item-details-name"
          className="truncate !text-lg !font-medium !leading-6 !tracking-tight !text-text-neutral-primary"
        >
          {name}
        </div>
      ) : (
        <EmptyFieldValue />
      )}
    </div>
  );
};
